import { Box, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';
import SendIcon from '@mui/icons-material/Send';

import { FormActionsProps } from './types';
import { AuthTabs } from '../../../../common/enums/auth';

export const FormActions: React.FC<FormActionsProps> = ({
  isSubmitting,
  isSignUp,
  checkDisabledButton,
  serverError,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        marginTop: '20px',
      }}
    >

      <LoadingButton
        variant="contained"
        color="primary"
        type="submit"
        endIcon={isSubmitting ? <SendIcon /> : null}
        loading={isSubmitting}
        disabled={checkDisabledButton()}
        disableRipple
        disableTouchRipple
        sx={{ minWidth: '200px' }}
      >
        {t(`userAuth.${isSignUp ? AuthTabs.SIGN_UP : AuthTabs.SIGN_IN}`)}
      </LoadingButton>

      {serverError && (
        <Typography
          variant="body1"
          textAlign="center"
          color={'error'}
          sx={{
            position: 'absolute',
            top: '-190%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '100%',
            fontSize: '14px',
          }}
        >
          {serverError}
        </Typography>
      )}
    </Box>
  );
}; 